import styled from 'styled-components';
import { colors } from "../../../../styles/colors";

interface IDropdown {
  opened: boolean;
  disable: boolean
}

export const Dropdown = styled.div<IDropdown>`
  display: flex;
  align-items: center;
  
  position: relative;
  width: 203px;
  height: 32px;
  box-sizing: border-box;
  border: 2px solid #364863;
  border-radius: 5px;
  padding: 0 10px 0 16px;
  background-color: white;
  user-select: none;
  
  font-size: 11px;
  color: #364863;
  font-weight: 400;
  cursor: ${ props => !props.disable ? 'pointer' : 'not-allowed' };

  ${ (props:any) => props.opened && 'border-radius: 5px 5px 0 0;'}

  ${ props => !props.disable && `
    &:hover {
      color:#364863; 

      .dropdwn-img {
        color: dark-gray;
      }
    }
  `}

  .selected {
    color: #364863;
  }

  .dropdwn-img {
    position: absolute;
    top: 9px;
    right: 16px;

    width: 14px;
    height: 12px;
    
    ${
      props => props.opened && (`transform: rotate(180deg);`)
    }
  }


  .options {
    display: ${ ({ opened }) => opened ? 'initial' : 'none'};

    position: absolute;
    left: -2px;
    top: 28px;
    z-index: 10;

    width: 203px;
    border: 2px solid #BCBCBC;
    border-radius: 0 0 5px 5px;
    background-color: #FFFFFF;
    overflow-y: auto;
    overflow-x: hidden;

  }

  .option {
    display: flex;

    padding-left: 16px;
    font-weight: 400;
    font-size: 11px;
    color: #364863;

    &:hover {
      background-color: ${ colors.greenDarkViveo };
      color: #FFFFFF;
    }
  }
`;